@if (buttonInTable()) {
  <button
    mat-icon-button
    class="package-indicator__button"
    [matTooltip]="`${ 'TRANS__SEARCH_VIEW__IN_PACKAGE__GO_TO' | translate} ${ packageName }`"
    [routerLink]="itemRouterLink"
  >
    <mat-icon class="package-indicator__icon package-indicator__icon--button">
      inventory_2
    </mat-icon>
  </button>
}
@else {
  <a
    class="package-indicator"
    [matTooltip]="`${ 'TRANS__SEARCH_VIEW__IN_PACKAGE__GO_TO' | translate} ${ packageName }`"
    [routerLink]="itemRouterLink"
    (click)="$event.preventDefault()"
  >
    <mat-icon class="package-indicator__icon">
      inventory_2
    </mat-icon>
  </a>

}
